module.exports = __webpack_public_path__ + "img/cup_ramen.182233c8.png";